import ActivateReadReceipt from "./ActivateReadReceipt";

export default ActivateReadReceipt;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/ReadReceiptCTA/ActivateReadReceipt/index.js